import React from "react";
import Accordion from "react-bootstrap/Accordion";
import "../../assets/css/terminos-mundial.css";

interface TerminosMundialComponentProps {
  worldCupData?: any;
}

const TerminosMundialComponent: React.FC<TerminosMundialComponentProps> = ({ worldCupData }) => {
  const accordionStyle = { border: '1px solid #ddd', borderRadius: '12px', overflow: 'hidden' };
  
  const termsContent = worldCupData?.terms_content || [];

  if (!worldCupData) {
    return null;
  }

  return (
    <section className="terminos-mundial-section">
      <div className="terminos-mundial-bg"></div>
      
      <div className="terminos-mundial-container">
        
        <h2 className="terminos-mundial-title">{worldCupData.terms_title}</h2>
        <p className="terminos-mundial-subtitle">
          {worldCupData.terms_subtitle}
        </p>
        
        <div className="terminos-mundial-card">
          <p className="terminos-mundial-text">
            {worldCupData.terms_description}
          </p>
          
          <hr className="terminos-mundial-divider" />
          
          <div className="terminos-mundial-list">
            <Accordion>
              {termsContent.map((item: any, index: number) => (
                <Accordion.Item key={item.id} eventKey={index.toString()} className="mb-3" style={accordionStyle}>
                  <Accordion.Header>{item.title}</Accordion.Header>
                  <Accordion.Body>
                    <div dangerouslySetInnerHTML={{ __html: item.description }} />
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>

      </div>
    </section>
  );
};

export default TerminosMundialComponent;